angular.module('presas')
    .factory('presasService', ['$http', '__env', function presasService($http, __env) {
        // Normaliza baseUrl para quitar barras finales
        var baseUrl = (__env.apiUrl || '').replace(/\/+$/, '');
        var presasUrl = 'presas';


    function getPresa(idInfraestructura) {
        return $http.get(baseUrl + '/' + presasUrl + "/" + idInfraestructura);
        }
    
    function getMensajes(presaId) {
        return $http.get(baseUrl + '/' + presasUrl + "/mensajes");
        }

    function getMedicionesSismografos(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/sismografos/" + idPresa);
        }

    function getMedicionesAcelerografos(idPresa) {
        return $http.get(baseUrl + '/' +presasUrl + "/acelerografos/" + idPresa);
        }

    function getMedicionesPluviometros(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/pluviometros/" + idPresa);
        }

    function getMedicionesAforadores(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/aforadores/" + idPresa);
        }

    function getMedicionesLimnimetros(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/limnimetros/" + idPresa);
        }

    function getMedicionesTermometros(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/termometros/" + idPresa);
        }

    function getMedicionesInclinometros(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/inclinometros/" + idPresa);
        }

    function getMedicionesClinometros(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/clinometros/" + idPresa);
        }

    function getMedicionesExtensometros(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/extensometros/" + idPresa);
        }

    function getMedicionesPendulos(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/pendulos/" + idPresa);
        }

    function getMedicionesPiezometros(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/piezometros/" + idPresa);
        }

    function getMedicionesTurbidimetros(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/turbidimetros/" + idPresa);
        }

    function getMedicionesSensores(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/sensores/" + idPresa);
        }

    function getMedicionesManometros(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/manometros/" + idPresa);
        }


    function getMedicionesCelulaspresion(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/celulaspresion/" + idPresa);
        }


    function getMedicionesSensoresPosicion(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/sensoresposicion/" + idPresa);
        }


    function getMedicionesElongametros(idPresa) {
        return $http.get(baseUrl + '/' + presasUrl + "/elongametros/" + idPresa);
        }


    return {
        getMensajes: getMensajes,
        getMedicionesSismografos: getMedicionesSismografos,
        getMedicionesAcelerografos: getMedicionesAcelerografos,
        getMedicionesPluviometros: getMedicionesPluviometros,
        getMedicionesAforadores: getMedicionesAforadores,
        getMedicionesLimnimetros: getMedicionesLimnimetros,
        getMedicionesTermometros: getMedicionesTermometros,
        getMedicionesInclinometros: getMedicionesInclinometros,
        getMedicionesExtensometros: getMedicionesExtensometros,
        getMedicionesClinometros: getMedicionesClinometros,
        getMedicionesPendulos: getMedicionesPendulos,
        getMedicionesPiezometros: getMedicionesPiezometros,
        getMedicionesTurbidimetros: getMedicionesTurbidimetros,
        getMedicionesSensores: getMedicionesSensores,
        getMedicionesManometros: getMedicionesManometros,
        getMedicionesCelulaspresion: getMedicionesCelulaspresion,
        getMedicionesSensoresPosicion: getMedicionesSensoresPosicion,
        getMedicionesElongametros: getMedicionesElongametros,
        getPresa: getPresa
        };
    }])


    .factory('WeatherService', ['$http', function ($http) {
        var base = 'https://api.open-meteo.com/v1/forecast';

        function buildUrl(lat, lon) {
            var params = [
                'latitude=' + encodeURIComponent(lat),
                'longitude=' + encodeURIComponent(lon),
                'timezone=Europe%2FMadrid',
                'forecast_days=3',
                'daily=precipitation_sum',
                'hourly=precipitation'
            ].join('&');

            return base + '?' + params;
        }

        return {
            getForecast: function (lat, lon) {
                return $http.get(buildUrl(lat, lon)).then(function (resp) {
                    return resp.data;
                });
            }
        };
    }]);